import React from "react";
import * as mfaAPI from "../services/mfaAPI";
import ContactCard from "./common-components/ContactCard";
import "../resources/styles/components/choose-contact.scss";
import { Redirect } from "react-router";
import { VerifyHeader } from "./common-components/VerifyHeader";
import NotificationModal from "./common-components/NotificationModal";
import { Modal } from "react-bootstrap";
import { errorMessages } from "../constants/error-messages";
import * as utils from "../util/utils";

type Props = {};
type State = {
    activeContactCard: boolean,
    resendDisabled: boolean,
    chosenContactInfo: string,
    redirect: boolean,
    mobile: string,
    email: string,
    showModal: boolean,
    modalBodyText: string,
    modalCloseButtonText: string,
    modalOnClose: Function,
};

/**
 * Component to let the user choose the contact method to receive their two-factor authentication code.
 */
export default class ChooseContact extends React.Component<Props, State>{
	constructor(props:Props) {
		super(props);

		this.state = {
            activeContactCard: true,
            resendDisabled: false,
            chosenContactInfo: '',
            redirect: false,
            mobile: '',
            email: '',
            showModal: false,
            modalBodyText: '',
            modalCloseButtonText: '',
            modalOnClose: this.closeModal
		}

        this.componentDidMount = this.componentDidMount.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
	}

    async componentDidMount() {
        const responseObject = await mfaAPI.getUserInfo();
        if (responseObject.errorMessages.length === 0){
            if (responseObject.userInfo.phoneNumber && responseObject.userInfo.phoneNumber.length > 0) {
                this.setState({
                    mobile: responseObject.userInfo.phoneNumber,
                    email: responseObject.userInfo.email,
                })
            } else {
                this.setState({
                    mobile: '',
                    activeContactCard: false,
                    email: responseObject.userInfo.email,
                })
            }
        } else { 
            this.setState({
                modalBodyText: responseObject.errorMessages[0],
                modalCloseButtonText: 'Home',
                modalOnClose: utils.returnToLogin,
                showModal: true,
            })
        }
    }

    /**
     * Control to open a modal
     */
    openModal() {
        this.setState({ showModal: true });
    }

    /**
     * Control to close a modal
     */
    closeModal() {
        this.setState({ showModal: false });
    }

    /**
     * Toggle which of the two cards is active.
     */
    toggleActiveCardHandler = () => {
        this.setState({activeContactCard: !this.state.activeContactCard});
    }

    /**
     * Handle send code button click
     * 
     * @param event 
     */
    submitHandler = async(event: any) => {
        event && event.preventDefault();
         // If true, text option was selected. Otherwise, email option was selected
        const chosenContactInfo = this.state.activeContactCard ? this.state.mobile : this.state.email;
        const codeSent = await mfaAPI.generateToken(this.state.activeContactCard);

        if (codeSent.success) { 
            this.setState({
                chosenContactInfo: chosenContactInfo,
                redirect: true,
                resendDisabled: false,
            })
        } else {
            const hasAuthError = errorMessages.AUTH_ERROR === codeSent.errorMessages[0];
            const hasTooManyError = errorMessages.TOO_MANY_ERROR === codeSent.errorMessages[0];
            if (hasTooManyError) {
                this.setState({
                    chosenContactInfo: chosenContactInfo,
                    redirect: true,
                    resendDisabled: true,
                })
            } else {
                this.setState({
                    modalBodyText: codeSent.errorMessages[0],
                    modalCloseButtonText: hasAuthError ? 'Home' : ' Retry',
                    modalOnClose: hasAuthError ? utils.returnToLogin : this.submitHandler,
                    showModal: true,
                })
            }
        }
    }

	render() {
		return (
            <>
                {this.state.redirect ? 
                    <Redirect to={{
                        pathname: '/verify-code',
                        state: {
                            activeContactCard: this.state.activeContactCard,
                            chosenContactInfo: this.state.chosenContactInfo,
                            hasPhoneNumbers: this.state.mobile.length > 0,
                            resendDisabled: this.state.resendDisabled,
                        }
                    }}    
                />
                : null}
                <VerifyHeader/>
                <form onSubmit={(e) => this.submitHandler(e)}>
                    <div className="mp-bold-text code-question-text">
                        How would you like to receive your security code?
                    </div>
                    <div className="row contact-card-row">
                        { this.state.mobile.length > 0 &&
                            <ContactCard
                                toggleActiveCardHandler={() => this.toggleActiveCardHandler()}
                                mobile={this.state.mobile}
                                activeCard={this.state.activeContactCard}
                                className={"mr-10"}
                            />
                        }
                        { this.state.email.length > 0 &&
                            <ContactCard
                                toggleActiveCardHandler={() => this.toggleActiveCardHandler()}
                                email={this.state.email}
                                activeCard={!this.state.activeContactCard}
                                className={this.state.mobile.length <= 0 ? "d-flex mx-auto" : "ml-10"}
                            />
                        }
                    </div>
                    <hr className="bottom-hr"/>
                    <div className="text-center">
                        <button type="submit" className={"mp-btn mp-btn-secondary mp-btn-large"} disabled={this.state.email.length === 0}>
                            Send Code
                        </button>
                    </div>
                </form>   
                <Modal show={this.state.showModal} onHide={() => this.closeModal()} animation={false} centered>
                    <NotificationModal
                        modalText={'Error'}
                        modalBodyText={this.state.modalBodyText}
                        modalCloseButtonText={this.state.modalCloseButtonText}
                        modalButtonHandler={() => this.state.modalOnClose()}
                        exitModalHandler={() => this.closeModal()}
                    />
                </Modal>  
            </>        
		);
	}
}